import React from 'react';
import { FormControlLabel, FormGroup, RadioGroup, Box } from '@material-ui/core';
import { Form, Input, Dropdown } from 'semantic-ui-react';
import { DatePicker, TimePicker } from 'antd';
import {Button } from "reactstrap";
import "moment/locale/es-mx";
import locale from "antd/es/date-picker/locale/es_ES";
import localeEN from "antd/es/date-picker/locale/en_US";

import CreateContext from '../../store/CreateContext';
import { RadioSelect, CheckSelect } from '../../components/RadioButtons';
import Header from '../../components/Header';
import CircleButton from '../../components/CircleButton';
import { Daily, Montly } from '../../model';
import { Days, Frequency, Months, AllDays } from './config';
import './styles.scss';
import { withNamespaces } from 'react-i18next';

/*=============================================
=            Schedule Report                  =
=============================================*/

function ScheduleReport(props) {
  const context = React.useContext(CreateContext);
  const [email, setEmail] = React.useState(undefined);
  const [emailAdd, setEmailAdd] = React.useState(false);

  const CheckBuilder = ({ data, handler, type }) => {
    return (
      <FormGroup>
        {data.map((item, ind) => (
          <FormControlLabel
            control={
              <CheckSelect
                icon={'check_circle'}
                handler={() => handler(item, type)}
                selected={context.config[type][item.value]}
                id={ind}
              ></CheckSelect>
            }
            label={
              <Box component="div" fontSize={12}>
                {props.t(item.label)}
              </Box>
            }
          />
        ))}
      </FormGroup>
    );
  };


  function handleChangeDateTime(data) {
    if (data.id === 'startDate') {
      context.update_config({ key: 'startDate', value: { value: data.value, dateString: data.dateString } });
    } else if (data.id === 'endDate') {
      context.update_config({ key: 'endDate', value: { value: data.value, dateString: data.dateString } });
    } else if (data.id === 'hour') {
      context.update_config({ key: 'hour', value: { value: data.value, timeString: data.timeString } });
    }
  }
  function handleChangeDay(evt, data) {
    context.update_config({ key: 'day', value: data.value });
  }

  function handleChange(evt) {
    if (evt.target.value) {
      context.set_frequency(evt.target.value);
      if (evt.target.value === 'Daily') {
        context.update_config({ key: 'Monthly', value: { ...Montly() } });
      } else if (evt.target.value === 'Monthly') {
        context.update_config({ key: 'Daily', value: { ...Daily() } });
      }
    }
  }

  function onUpdateRecurrance(item, type) {
    if (type === 'Daily') {
      context.config[type][item.value] = !context.config[type][item.value];
      context.update_config({ key: 'Daily', value: { ...context.config[type] } });
    } else if (type === 'Monthly') {
      context.config[type][item.value] = !context.config[type][item.value];
      context.update_config({ key: 'Monthly', value: { ...context.config[type] } });
    }

  }

  function onChangeEmail(evt, data) {
    if (data.value) {
      if (validateEmail(data.value)) {
        // if(validateEmail(email)){
        setEmail(data.value);
        if (!emailAdd) {
          setEmailAdd(true);
        }
      } else {
        setEmail(data.value);
        setEmailAdd(false);
      }
    } else {
      setEmail('');
      setEmailAdd(false);
    }
  }

  function validateEmail(email) {
    const regexEmail = new RegExp(/^\S+@\S+\.\S+$/);
    // const regexEmail = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/);
    return regexEmail.test(email);
  }
  function onAddEmail() {
    context.add_email(email);
    setEmail('');
    setEmailAdd(false);
  }
  function onADD(evt) {
    if (validateEmail(email) && evt.key === 'Enter') {
      onAddEmail();
    }
  }



  return (
    <div className='col-md-12' hidden={context.report_type === 'scheduled' ? false : true}>
      <Header
        as='h6'
        icon='clock'
        title={props.t("scheduled")}

      />
      <div className='col-md-12'>
        <div className='row'>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-6 d-flex justify-content-end'>
                <p className='colorFuente schedule-title'>{props.t("frecuency")}</p>
              </div>
              <div className='col-md-6'>
                <RadioGroup aria-label="frequency" id='frequency' name="frequency" value={context.config.frequency} onChange={(event) => {
                  handleChange(event);
                }}>
                  {
                    Frequency.map((item, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          value={item.value}
                          id={index}
                          control={
                            <RadioSelect />
                          }
                          label={<Box component="div" fontSize={12}>
                            {props.t(item.label)}
                          </Box>}
                        />
                      );
                    })
                  }
                </RadioGroup>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-6 d-flex justify-content-end'>
                <p className='schedule-title colorFuente'>{props.t("recurrence")}</p>
              </div>
              <div className='col-md-6'>
                {
                  context.config.frequency === 'Daily' ?
                    <CheckBuilder data={Days} handler={onUpdateRecurrance} type='Daily' /> :
                    <CheckBuilder data={Months} handler={onUpdateRecurrance} type='Monthly' />
                }
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-12'>
                <label className='colorFuente schedule-label'>{props.t("start_date")}</label>
                <DatePicker placeholder={props.t("start_date")} className={'datetime-picker-schedule'}
                  value={context.config.startDate.value} format={'DD-MM-YYYY'} bordered={true} onChange={(date, dateString) => { handleChangeDateTime({ value: date, dateString, id: 'startDate' }); }} />
              </div>
              <div className='col-md-12'>
                <label className='colorFuente schedule-label'>{props.t("endind_date")}</label>
                <DatePicker placeholder={props.t("endind_date")} className={'datetime-picker-schedule'}
                  value={context.config.endDate.value} format={'DD-MM-YYYY'} bordered={true}
                  onChange={(date, dateString) => { handleChangeDateTime({ value: date, dateString, id: 'endDate' }); }} />
              </div>
              <div className='col-md-12' hidden={context.config.frequency === 'Daily' ? true : false}>
                <label className='colorFuente schedule-label'>{props.t("day")}</label>
                <Form size='tiny'>
                  <Form.Group>
                    <Form.Field required width={16}>
                      <Dropdown fluid search selection options={AllDays()} className={'clearable-fix schedule-days'} placeholder='Dia' id='day' name='day' onChange={handleChangeDay} value={`${context.config.day}`} />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </div>
              <div className='col-md-12'>
                <label className='colorFuente schedule-label'>{props.t("time")}</label>
                <TimePicker placeholder={props.t("time")} className={'time-picker-schedule'}
                  use12Hours format="h:mm a"
                  locale={props.lng == "US" ? localeEN : locale}
                  value={context.config.hour.value}
                  onChange={(time, timeString) => { handleChangeDateTime({ value: time, timeString, id: 'hour' }); }}
                />
              </div>
              <div className='col-md-12'>
                <label className='colorFuente schedule-label'>{props.t("time_zone")}</label>
                <p className='class-neutral-grey'>{context.config.timeZoneStr}</p>
              </div>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='row'>
              <div className='col-md-12'>
                <label className='colorFuente schedule-label'>{props.t("send_to_colon")}</label>
                <div className='row' style={{ alignItems: "center" }}>
                  <div className='col-md-9'>
                    <Form size='tiny'>
                      <Form.Group>
                        <Form.Field required width={16} size={'tiny'}>
                          <Input size='tiny' placeholder={props.t("email")} id='sendTo' autoComplete="off" name='sendTo' value={email} onChange={onChangeEmail} onKeyPress={onADD} />
                        </Form.Field>
                      </Form.Group>
                    </Form>
                  </div>
                  <div className='col-md-3' style={{ marginBottom: "5%", paddingLeft: "0" }}>
                    {/* <CircleButton onClick={onAddEmail}
                      title={"add"}
                      icon={'add'} disabled={!emailAdd} /> */}
                      <Button
                      color="primary"
                      icon={'add'}
                      onClick={onAddEmail}
                      disabled={!emailAdd}
                      className='btn-circle-add-email'
                      >

                      <span className="icon-plus icon-button-add no-margin" />
                      </Button>
                  </div>
                </div>

              </div>
              <div className='col-md-12'>
                <label className='colorFuente schedule-label'>{props.t("email_list")}</label>
                <div className='d-flex flex-column email'>
                  {
                    context.emailList.map((email, index) => {
                      return (
                        <div className='d-flex align-items-center email__container' key={index}>
                          <div className='email__item'>
                            <label className='colorFuente'>{email}</label>
                          </div>
                          <div className='email__action'>
                           <span title={"delete"}onClick={() => { context.remove_email(email); }} className="icon-delete icons-front-module module-report" />
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withNamespaces()(ScheduleReport);